module.exports = "label{width:100%}input{width:100%;height:100%}:host{width:9em !important}.fa-calendar-day{color:#cfcfcf;font-size:12px}\n"